import React, { useRef, useState, useEffect } from "react";
import { Card, Col, Row, Spin, message, Modal } from "antd";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RoundIcon from "atoms/RoundIcon";
import AddEditPolicy from "./AddEditPolicy";
import COLORS from "common/Colors";
import JsPDF from "jspdf";
import html2canvas from "html2canvas";
import { CALL_API } from "common/API";
import { Spinner } from "react-bootstrap";
import { STATUS_CODE } from "common/Constants";
import Icon from "atoms/Icon";
import styled from "styled-components";
import download from "downloadjs";

const StyledDocumentModal = styled(Modal)`
  height: 100vh;
  max-width: 80rem;
  padding: 1%;
  width: 100%;

  .ant-modal-content {
    height: 100vh;
    width: 100%;
    box-shadow: none;
  }
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .iframe {
    width: 100%;
    height: 100vh;
  }
  .file_fit {
    width: 100%;
    height: 100%;
    border: none;
  }
  .img_fit {
    max-width: 90vw;
    max-height: 90vh;
  }
`;

const StyledCol = styled(Col)`
  margin: 10px;
  .normal-column {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const StyledIcon = styled(Icon)`
  height: 60px;
  width: 60px;
`;

function Details({
  selectedRow,
  ClientId,
  userInfo,
  goBack,
  getPolicyData,
  deletePolicy,
  Menulist,
  pagetitle,
}) {
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const containerRef = useRef(null);
  const [previewURL, setPreviewURL] = useState("");
  const [isLoadingDocuments, toggleLoadingDocuments] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewType, setPreviewType] = useState("");

  // 📌 detect mobile webview (flutter)
  const isMobileWebView = () => {
    const ua = navigator.userAgent || "";
    return /wv|Android|iPhone|iPad/i.test(ua);
  };

  const deleteData = async (id) => {
    deletePolicy(id);
    goBack();
    await CALL_API(
      `hrpolicy/${ClientId}?policyId=${selectedRow?.policyId}`,
      "delete",
      {}
    );
  };

  // 📌 PDF generate
  const generatePDF = () => {
    setLoading(true);
    const reportElement = containerRef.current;
    const reportWidth = 595.28;
    const reportHeight = 841.89;
    const margin = 20;

    html2canvas(reportElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new JsPDF("p", "pt", [reportWidth, reportHeight]);

      const contentWidth = reportWidth - 2 * margin;
      const contentHeight = (canvas.height / canvas.width) * contentWidth;

      pdf.addImage(imgData, "PNG", margin, margin, contentWidth, contentHeight);
      pdf.save(`${selectedRow?.policyTitle}.pdf`);
      setLoading(false);
    });
  };

  // 📌 preview click
  const handlePreviewClick = async (docId, policyId, name) => {
    const ext = name?.split(".")?.pop()?.toLowerCase();
    setPreviewType(ext);
    toggleLoadingDocuments(true);

    const { code, url } = await CALL_API(`document-list/${ClientId}`, "post", {
      method: "preview-policy-document",
      documentId: docId,
      policyId: policyId,
    });

    if (code === STATUS_CODE.SUCCESS) {
      // 🔥 IMAGE
      if (["jpg", "png", "jpeg", "svg"].includes(ext)) {
        setPreviewURL(url);
        setIsPreviewModalOpen(true);
      }

      // 🔥 PDF FIX (Flutter WebView compatible)
      else if (ext === "pdf") {
        if (isMobileWebView()) {
          // google viewer fix
          const viewerUrl =
            "https://docs.google.com/gview?embedded=true&url=" +
            encodeURIComponent(url);
          setPreviewURL(viewerUrl);
        } else {
          setPreviewURL(url);
        }
        setIsPreviewModalOpen(true);
      }

      // 🔥 other files
      else {
        download(url);
      }
    } else {
      message.error("Something went wrong!! Please try again.");
    }

    toggleLoadingDocuments(false);
  };

  const Menu = () => {
    const iconStyle = { color: "#000", fontSize: "18px" };
    return (
      <Row gutter={16} className="d-flex gap-2">
        <RoundIcon onClick={generatePDF}>
          {loading ? (
            <Spinner animation="border" variant="light" size="sm" />
          ) : (
            <LocalPrintshopIcon style={iconStyle} />
          )}
        </RoundIcon>

        <RoundIcon onClick={() => setIsEdit(true)}>
          <EditIcon style={iconStyle} />
        </RoundIcon>

        <RoundIcon onClick={() => deleteData(selectedRow?.policyId)}>
          <DeleteIcon style={iconStyle} />
        </RoundIcon>
      </Row>
    );
  };

  const titleStyle = { color: COLORS.BLACK, cursor: "pointer" };

  return (
    <div>
      <h6>
        <strong style={titleStyle} onClick={() => goBack()}>
          {pagetitle}
        </strong>{" "}
        <span>
          {" "}
          {">"} {selectedRow?.policyTitle}
        </span>
      </h6>

      {!isEdit && (
        <Card type="inner" title={selectedRow?.policyTitle}>
          {selectedRow?.policyDocument?.length > 0 && (
            <StyledCol>
              <Row>
                {selectedRow?.policyDocument?.map((item, key) => (
                  <Col
                    sm={24}
                    md={8}
                    xl={6}
                    key={key}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handlePreviewClick(
                        item?.documentId,
                        selectedRow?.policyId,
                        item?.name
                      )
                    }
                  >
                    <Icon name="pdf" style={{ StyledIcon }} />
                    <p className="normal-column">{item?.name}</p>
                  </Col>
                ))}
              </Row>
            </StyledCol>
          )}
        </Card>
      )}

      {isEdit && (
        <AddEditPolicy
          ClientId={ClientId}
          userInfo={userInfo}
          value={selectedRow}
          goBack={() => goBack()}
          getPolicyData={() => getPolicyData()}
        />
      )}

      {/* 🔥 PREVIEW MODAL */}
      <StyledDocumentModal
        centered
        open={isPreviewModalOpen}
        footer={false}
        width="100%"
        onCancel={() => setIsPreviewModalOpen(false)}
      >
        <Spin spinning={isLoadingDocuments}>
          {["jpg", "png", "jpeg", "svg"].includes(previewType) ? (
            <div className="img">
              <img src={previewURL} className="img_fit" alt="preview" />
            </div>
          ) : (
            <div className="iframe">
              <iframe className="file_fit" src={previewURL} title="preview" />
            </div>
          )}
        </Spin>
      </StyledDocumentModal>
    </div>
  );
}

export default Details;
